<template>
  <tr>
    <td class="text-overflow">
      <strong>{{ post.title }}</strong>
    </td>
    <td class="text-overflow">
      {{ post.excerpt || (post.body ? post.body.substring(0, 100) + '...' : 'No description') }}
    </td>
    <td class="text-overflow">
      {{ post.creator ? post.creator.name : 'Unknown' }}
    </td>
    <td class="text-overflow">
      {{ postCommunities }}
    </td>
    <td class="text-overflow">
      {{ formatDate(post.created_at) }}
    </td>
    <td>
      <ds-button
        size="sm"
        variant="secondary"
        @click="$emit('preview', post)"
        label="Preview"
      >
      </ds-button>
    </td>
    <td>
      <ds-button
        size="sm"
        variant="success"
        @click="handleApprove"
        :loading="approving"
        label="Approve"
      >

      </ds-button>
    </td>
    <td>
      <ds-button
        size="sm"
        variant="danger"
        @click="handleReject"
        :loading="rejecting"
        label="Reject"
      >
      </ds-button>
    </td>
  </tr>
</template>

<script>
  import { approvePost, rejectPost } from '../../Domain/KnowledgeBase/Api/knowledgeBase'

  export default {
    name: 'RowCurationKnowledgeBase',
    props: {
      post: {
        type: Object,
        required: true
      }
    },
    emits: ['approved', 'rejected', 'preview'],
    data () {
      return {
        approving: false,
        rejecting: false
      }
    },
    computed: {
      postCommunities () {
        let communities = []
        this.post.communities.forEach((community) => {
          communities.push(community.name)
        })

        return communities.join(', ')
      }
    },
    methods: {
      formatDate (date) {
        if (!date) return 'Unknown'
        return new Date(date).toLocaleDateString()
      },
      async handleApprove () {
        if (this.approving) return

        this.approving = true
        try {
          await approvePost(this.post.id, this.post.community_id)

          this.$notify({
            type: 'success',
            title: 'Success',
            text: 'Knowledge base post approved successfully'
          })

          this.$emit('approved', this.post)
        } catch (error) {
          console.error('Error approving post:', error)
          this.$notify({
            type: 'error',
            title: 'Error',
            text: error.response?.data?.message || 'Failed to approve post'
          })
        } finally {
          this.approving = false
        }
      },
      async handleReject () {
        if (this.rejecting) return

        this.rejecting = true
        try {
          await rejectPost(this.post.id, this.post.community_id)

          this.$notify({
            type: 'success',
            title: 'Success',
            text: 'Knowledge base post rejected successfully'
          })

          this.$emit('rejected', this.post)
        } catch (error) {
          console.error('Error rejecting post:', error)
          this.$notify({
            type: 'error',
            title: 'Error',
            text: error.response?.data?.message || 'Failed to reject post'
          })
        } finally {
          this.rejecting = false
        }
      }
    }
  }
</script>

<style scoped>
  .text-overflow {
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
